import React, { useEffect, useState } from 'react';

const PostcodeSearch = ({ currentQuestion, answers, storeAnswers, selectedAnswer, removeAnswer }) => {
    const [searchText, setSearchText] = useState('');
    const [eligible, setEligible] = useState(null);

    useEffect(() => {
        const defaultSearchText = selectedAnswer && selectedAnswer.hasOwnProperty('text') ? selectedAnswer.text : '';

        setSearchText(defaultSearchText);
    }, [selectedAnswer]);

    const handleSearchClick = (event) => {
        const searchString = searchText.replace(/\s+/g, '');

        fetch('https://nu-partners-api.herokuapp.com/api/v1/postcode/by-postcode/' + searchString.toUpperCase())
            .then(function (response) {
                if (response.status !== 200) {
                    console.error('Looks like there was a problem. Status Code: ' + response.status);
                    return;
                }

                response.json().then(function (data) {
                    console.log(data.postcode, data.eligible);
                    setEligible(data.eligible);

                    storeAnswers(
                        0,
                        {
                            text: searchText,
                            eligible: data.eligible,
                            nextQuestion: !data.eligible ? answers.nextQuestion : null,
                        },
                        currentQuestion
                    );
                });
            })
            .catch(function (error) {
                console.error(error);
            });
    };

    const handleSearchTextChange = (event) => {
        removeAnswer(currentQuestion);
        setSearchText(event.target.value);
    };

    const handleOnKeyPressed = (e) => {
        const code = e.keyCode || e.which;
        if (code === 13) {
            //13 is the enter keycode
            handleSearchClick();
        }
    };

    const inputClasses = eligible === false ? 'searchText error' : 'searchText';

    return (
        <div className='searchWrapper'>
            <input
                className={inputClasses}
                type='text'
                onChange={handleSearchTextChange}
                onKeyUp={handleOnKeyPressed}
                value={searchText}
                defaultValue={searchText}
            />
            <button className='searchTextIcon' onClick={handleSearchClick} />
            {eligible === false && (
                <p className='searchMessage error'>
                    Your postcode does not meet our eligibility requirements. Click 'Continue' to check if you meet one
                    of our other eligibility criteria.
                </p>
            )}
            {eligible === true && (
                <p className='searchMessage success'>
                    Congratulations, your postcode meets our eligibility requirements.
                </p>
            )}
        </div>
    );
};

export default PostcodeSearch;
